module.exports = __webpack_public_path__ + "img/mighty_boar.4d08dd16.png";